/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_HintInputs */

const cs_property_registry_hint = /** @type {(inputs: Property_Registry_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katastr (KN), výpis LV, ARES, ISIR a CEE — vedle sebe pro rychlou lustraci.`)
};

const en_property_registry_hint = /** @type {(inputs: Property_Registry_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre (KN), LV extract, ARES, ISIR, and CEE — side by side for quick checks.`)
};

/**
* | output |
* | --- |
* | "Cadastre (KN), LV extract, ARES, ISIR, and CEE — side by side for quick checks." |
*
* @param {Property_Registry_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_hint = /** @type {((inputs?: Property_Registry_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_hint(inputs)
	return cs_property_registry_hint(inputs)
});